import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import {
  courseDetailsCrudStateConfig,
  courseCrudStateConfig,
  courseSectionsCrudStateConfig,
  sectionCrudStateConfig
} from "../const";

const { fetchActionFactory: fetchCourseDetailsActionFactory } =
  makeCrudStateActionFactories(courseDetailsCrudStateConfig);

const { fetchActionFactory: fetchCourseActionFactory } =
  makeCrudStateActionFactories(courseCrudStateConfig);

const { fetchActionFactory: fetchCourseSectionsActionFactory } =
  makeCrudStateActionFactories(courseSectionsCrudStateConfig);

const { fetchActionFactory: fetchSectionActionFactory } =
  makeCrudStateActionFactories(sectionCrudStateConfig);

export {
  fetchCourseDetailsActionFactory,
  fetchCourseActionFactory,
  fetchCourseSectionsActionFactory,
  fetchSectionActionFactory
};
